import { Box, Stack } from "@mui/material";
import ProfessionalItem from "./ProfessionalItem";

const ProfessionalSidebarSection = (menu) => {
  return (
    <Box
      justifyContent="space-evenly"
      sx={{
        ml: 0.5,
        minHeight: 248,
        width: 48,
        maxHeight: 250,
        py: 2,
        backgroundColor: "grey.gb",
        position: "relative",
        backgroundClip: "padding-box !important",
        border: "1px solid transparent",
        borderRadius: 1000,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: -1,
          margin: "-1.6px !important",
          borderRadius: "inherit !important",
          background: (theme) => `${theme.palette.gradients.secondary} !important`,
        },
      }}
    >
      <Stack overflow={"hidden"} maxHeight={"240px"}>
        <Box
          sx={{
            maxHeight: 200,
            overflowY: "auto",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            gap: 1,
            width: "100%",
            p: 0,
            m: 0,
            borderRadius: "inherit",
            "&::-webkit-scrollbar": {
              width: "3px",
            },
          }}
        >
          {menu?.menu?.map((val, index) => (
            <ProfessionalItem menu={val} key={index} />
          ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default ProfessionalSidebarSection;
